import React from 'react';
import Header from './Header';
import Footer from './Footer';
import EmergencyButton from '../common/EmergencyButton';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <EmergencyButton />
    </div>
  );
};

export default Layout;